import SmCrypto from 'sm-crypto'
import JsMd5 from 'js-md5'
import CryptoJs from 'crypto-js'
import { decode } from './base'
const PRIVATE_KEY = decode([2, 6, 7, 15, 17, 20, 15, 15, 21, 13, 25, 26, 24, 24, 26, 28, 27, 32, 30, 19, 22, 32, 37, 38, 27, 36, 36, 37, 37, 33, 44, 39, 43, 45, 36, 42, 40, 47, 40, 48, 43, 50, 47, 53, 45, 59, 54, 53, 52, 55, 62, 56, 67, 65, 65, 60, 66, 65, 68, 62, 62, 74, 70, 66])
const PUBLIC_KEY = decode([0, 5, 7, 7, 18, 19, 15, 7, 15, 9, 25, 22, 15, 27, 21, 29, 21, 17, 30, 28, 22, 30, 32, 35, 27, 27, 32, 31, 38, 39, 41, 34, 46, 38, 39, 49, 44, 45, 38, 53, 55, 52, 46, 43, 52, 51, 58, 58, 53, 51, 51, 60, 56, 62, 65, 61, 69, 65, 58, 74, 70, 75, 64, 76, 77, 68, 68, 68, 74, 70, 83, 83, 87, 74, 79, 88, 77, 87, 82, 92, 83, 85, 94, 83, 95, 94, 101, 91, 96, 94, 103, 104, 102, 107, 104, 96, 108, 101, 111, 113, 111, 109, 113, 104, 105, 105, 108, 114, 110, 113, 112, 126, 112, 116, 121, 115, 129, 127, 127, 134, 127, 132, 136, 124, 129, 134, 140, 133, 142, 143])
const SM4_KEY = decode([15, 14, 4, 13, 4, 18, 13, 8, 21, 21, 17, 12, 13, 14, 20, 21, 24, 27, 21, 34, 25, 23, 30, 25, 30, 34, 31, 41, 34, 40, 43, 45])

/**
 * SM2签名C1C2C3
 */
const sm2Sign123 = content => sm2Sign(content, 0)

/**
 * SM2验签C1C2C3
 */
const sm2Check123 = (content, sign) => sm2Check(content, sign, 0)

/**
 * SM2签名C1C3C2
 */
const sm2Sign132 = content => sm2Sign(content, 1)

/**
 * SM2验签C1C3C2
 */
const sm2Check132 = (content, sign) => sm2Check(content, sign, 1)

/**
 * SM2加密C1C2C3
 */
const sm2Encrypt123 = (content, publicKey) => sm2Encrypt(content, 0, publicKey)

/**
 * SM2解密C1C2C3
 */
const sm2Decrypt123 = (content, privateKey) => sm2Decrypt(content, 0, privateKey)

/**
 * SM2加密C1C3C2
 */
const sm2Encrypt132 = (content, publicKey) => sm2Encrypt(content, 1, publicKey)

/**
 * SM2解密C1C3C2
 */
const sm2Decrypt132 = (content, privateKey) => sm2Decrypt(content, 1, privateKey)

/**
 * SM3加密
 */
const sm3Encrypt = content => {
  if (!content) return null
  const sm3 = SmCrypto.sm3
  return sm3(md5(content))
}

/**
 * SM4加密
 */
const sm4JsEncrypt = (content, sm4Key) => {
  if (!content) return null
  const sm4 = SmCrypto.sm4
  return sm4.encrypt(content, sm4Key === undefined || sm4Key === null || sm4Key === '' ? SM4_KEY : sm4Key)
}

/**
 * SM4解密
 */
const sm4JsDecrypt = (content, sm4Key) => {
  if (!content) return null
  const sm4 = SmCrypto.sm4
  const sm4Decrypt = sm4.decrypt(content, sm4Key === undefined || sm4Key === null || sm4Key === '' ? SM4_KEY : sm4Key)
  if (!sm4Decrypt) return content
  return sm4Decrypt
}

/**
 * md5加密
 */
const md5 = content => {
  if (!content) return null
  return JsMd5(content)
}

/**
 * des加密
 */
const desEncrypt = (key, content) => {
  if (!key || !content) return null
  return CryptoJs.DES.encrypt(content, CryptoJs.enc.Utf8.parse(key), {
    mode: CryptoJs.mode.ECB,
    padding: CryptoJs.pad.Pkcs7
  }).ciphertext.toString()
}

/**
 * des解密
 */
const desDecrypt = (key, content) => {
  if (!key || !content) return null
  return CryptoJs.DES.decrypt({ ciphertext: CryptoJs.enc.Hex.parse(content) }, CryptoJs.enc.Utf8.parse(key), { mode: CryptoJs.mode.ECB, padding: CryptoJs.pad.Pkcs7 }).toString(CryptoJs.enc.Utf8)
}

export default {
  sm2Sign123,
  sm2Encrypt123,
  sm2Decrypt123,
  sm2Check123,
  sm2Sign132,
  sm2Encrypt132,
  sm2Decrypt132,
  sm2Check132,
  sm3Encrypt,
  sm4JsEncrypt,
  sm4JsDecrypt,
  md5,
  desEncrypt,
  desDecrypt
}

/**
 * SM2签名
 */
const sm2Sign = (content, type) => {
  if (!content) return null
  return sm2Encrypt(sm3Encrypt(content), type)
}

/**
 * SM2加密
 */
const sm2Encrypt = (content, type, publicKey) => {
  if (!content) return null
  const sm2 = SmCrypto.sm2
  return '04' + sm2.doEncrypt(content, publicKey === undefined || publicKey === null || publicKey === '' ? PUBLIC_KEY : publicKey, type)
}

/**
 * SM2解密
 */
const sm2Decrypt = (content, type, privateKey) => {
  if (!content) return null
  if (content.indexOf('04') === 0) content = content.slice(2)
  const sm2 = SmCrypto.sm2
  const sm2Decrypt = sm2.doDecrypt(content, privateKey === undefined || privateKey === null || privateKey === '' ? PRIVATE_KEY : privateKey, type)
  if (!sm2Decrypt) return content
  return sm2Decrypt
}

/**
 * SM2验签
 */
const sm2Check = (content, sign, type) => {
  if (!content || !sign) return false
  return sm3Encrypt(content) === sm2Decrypt(sign, type)
}
